module.exports = __webpack_public_path__ + "img/food-force-main-features.a1f4e850.png";